module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/ng-image__3-078b51777c97ccd2efa27be8e0d1a601.png";